import { Injectable } from '@angular/core';
import { WeaponType } from '../weapons/weapon-type';
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PlayerService {
    currentWeapon = WeaponType.Fist;
    public health$ = new BehaviorSubject<{health: number, damage?: number}>(undefined);
    public playerState$ = new BehaviorSubject<string>('');
    health: number;

    constructor() {
    }

    setCurrentWeapon(weapon: WeaponType): void {
        this.currentWeapon = weapon;
    }

    getCurrentWeapon(): WeaponType {
        return this.currentWeapon;
    }

    getPlayerHealth(): number {
        return this.health;
    }

    setPlayerHealth(health: number, damage?: number): void {
        if (health > 0) {
            this.health$.next({ health, damage });
        }
        this.health = health;
    }
}
